module.exports = __webpack_public_path__ + "static/img/7.ce1b100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/7.png
// module id = IedQ
// module chunks = 0